import React from 'react';
import PropTypes, { checkPropTypes } from 'prop-types';
import { Button, Icon } from '@sumtotal/react-foundation';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import authService from '../../../authentication/AuthorizeService';
import getLogger from '../../../utils/logger';

const Strip = styled.div`
  min-height: 2.1875rem;
  background-color: #f8b300;
  font-size: 0.875rem;
  color: #000;
  margin: 0.125rem;
  text-align: center;
`;

const Text = styled.span`
  padding: 0.5rem 0;
  display: inline-block;
  width: 70%;
  font-weight: 600;
`;

const ExitEmulationBtn = styled(Button)`
  color: #000;
  float: right;
  &:hover {
    background-color: transparent;
    color: #000;
  }
  &:active {
    color: #000;
    background-color: transparent;
  }
  &:focus {
    color: #000;
    background-color: transparent;
  }
`;

function EmulationStrip(props) {
  const {
    emulatedUser = defaultProps.emulatedUser,
    exitEmulationUrl = defaultProps.exitEmulationUrl
  } = props;
  checkPropTypes(EmulationStrip.propTypes, props, 'prop', EmulationStrip.name);
  const { t } = useTranslation(['TRANSLATIONS_RCORE_TOPNAV']);

  const handleExitEmulation = () => {
    authService
      .removeAccessToken()
      .then(() => {
        window.location.assign(exitEmulationUrl);
        return null;
      })
      .catch((err) => {
        getLogger().error(err);
      });
  };

  if (emulatedUser && emulatedUser !== '') {
    return (
      <>
        <Strip className="sticky-header no-print">
          <Text>
            {t('RCORE_TOPNAV_EMULATION_TEXT', {
              username: emulatedUser,
              interpolation: { escapeValue: false }
            })}
          </Text>
          <ExitEmulationBtn
            id="exitEmulationBtn"
            endIcon={<Icon iconName="Close" />}
            variant="text"
            onClick={handleExitEmulation}
          >
            {t('RCORE_TOPNAV_EXIT_EMULATION')}
          </ExitEmulationBtn>
        </Strip>
      </>
    );
  }
  return null;
}

// PropType check
EmulationStrip.propTypes = {
  /**
   * isEmulationMode flag to detect emulation mode
   */
  emulatedUser: PropTypes.string,
  /**
   * url for exit emulation
   */
  exitEmulationUrl: PropTypes.string
};

const defaultProps = {
  emulatedUser: '',
  exitEmulationUrl: ''
};

export default EmulationStrip;
